module.exports = __webpack_public_path__ + "img/radiaIcon5.80e6574b.svg";